<template>
  <div>
    <!-- navbar -->
    <div class="ui big fixed menu inverted" id="top-menu">
      <div class="header item logo-padding" style="">
        <h3 class="logo-ward">Clinicmngr</h3>
      </div>
      <div class="right menu right-menu-margin" style="margin-right: 20px;">
        <a class="item" style="cursor: pointer;" href="#">
          {{ $t('signIn') }}
        </a>
        <a class="item" style="cursor: pointer;" href="#">
          {{ $t('aboutUs') }}
        </a>
        <a class="item" style="cursor: pointer;" href="#">
          {{ $t('concerns') }}
        </a>
        <a class="item" style="cursor: pointer;" href="#">
          {{ $t('reviews') }}
        </a>
        <a class="item" style="cursor: pointer;" href="#">
          {{ $t('contactUs') }}
        </a>
      </div>
    </div>

    <!-- login div -->
    <div id="loginDiv" style="height: 750px;">
      <div id="login">
        <img src="@/assets/logo.png" alt="">
        <div id="loginForm" >
          <div class="ui middle aligned center aligned grid">
            <div class="column">
              <h2 class="ui header">
                <div class="content" style="color: white">
                  Log-in to your account
                </div>
              </h2>
              <form class="ui large form" >
                <div v-if="loginError" class="ui negative message" style="width: 80%; margin-left: 10%;">
                  email or the password is incorrect
                </div>
                <div class="ui segment" style="background-color: rgba(9,36,66,0); border: 0px;">
                  <div class="field">
                    <div class="ui left icon input">
                      <i class="user icon"></i>
                      <input type="text" name="email" placeholder="E-mail address" v-model="userLoginInfo.email">
                    </div>
                  </div>
                  <div class="field">
                    <div class="ui left icon input">
                      <i class="lock icon"></i>
                      <input 
                        type="password" 
                        name="password" 
                        placeholder="Password" 
                        v-model="userLoginInfo.password"
                        @keyup.enter="login()"
                      >
                    </div>
                  </div>
                  <div class="ui fluid large button" @click="login()">Login</div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <CoworgObjective  id="work" style="background-color: white;"></CoworgObjective>

    <div class="ui vertical stripe quote segment" id="concerns" style="background-color: white;">
      <div class="ui stackable grid">
        <div class="ui six wide inverted column"
             style="display: flex;align-items: center; background-color:#1d2537;"
             id="diagonal-border">
          <h3 class="ui header"
              style="text-align: center; color: white; margin-left: 30px; font-size: 2vw">
            What are our concerns ?
          </h3>
        </div>
        <div class="ui ten wide column"
              style="padding-top: 1em; padding-bottom: 1em; height: 250px">
          <Slider></Slider>
        </div>
      </div>
    </div>

    <div class="ui vertical stripe quote segment" id="reviews" style="background-color: white;">
      <div class="ui equal width stackable internally celled grid" style="height: 35vh">
        <div class="center aligned row">
          <div class="column">
            <h3>
              "This is an awesome website, I'm glad that i use it."
            </h3>
            <p>
              That is what all doctors say about us
            </p>
          </div>
<!--           <div class="column">
            <h3>
              "It gives me a smooth way to control my clinic problems."
            </h3>
            <p>
              That is what a working space would say about us.
            </p>
          </div> -->
        </div>
      </div>
    </div>

    <!-- Contact Us -->
    <!-- <div class="ui vertical stripe segment" id="contact-us" style="background-color: white;">
      <div class="ui center grid">
        <ContactUs></ContactUs>
      </div>
    </div> -->

    <UserFooter style="background-color: #092442;"></UserFooter>
  </div>
</template>

<script>
export default {
  components: {
    Slider: require('@/components/landing-page/start_page_components/Slider').default,
    ContactUs: require('@/components/landing-page/start_page_components/ContactUs').default,
    CoworgObjective: require('@/components/landing-page/start_page_components/CoworgObjective').default,
    UserFooter: require('@/components/abstract_components/Footer').default
  },
  data () {
    return {
      userLoginInfo: {
        email: '',
        password: '',
      },
      loginError: false
    }
  },
  beforeMount () {
    this.changeStyleSheet('en')
  },
  methods: {
    login () {
      this.$auth.login({
        data: this.userLoginInfo,
        success: response => {
          this.checkAuthenticationReady(() => {
            this.fetchData()
          })
        },
        error: (error) => {
          this.loginError = true
          console.log(error)
        },
        rememberMe: true,
        fetchUser: true
      }).catch(error => { console.log(error) })
    }
  }
}
</script>

<style scoped>
#top-menu {
  width: 100vw;
  z-index: 504;
  border-right-color: white;
  background-color: #092442;
  border-bottom-color: #2e353d;
}
#loginDiv::before {
  background-image: url('~@/assets/details.jpg');
  background-size: cover;
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -2;
  opacity: 0.68;
}

#login {
  height: 650px;
  background-color: rgba(0,0,0,0.6);
  width: 25vw;
  overflow: hidden;
  margin-left: 70%;
}

#loginForm {
  /*height: 90vh !important;*/
}

img {
  margin-top: 35px;
  margin-left: 10%;
  width: 80%;
}
.hidden.menu {
  display: none;
}

.masthead.segment {
  min-height: 600px;
  padding: 1em 0em;
}
.masthead .logo.item img {
  margin-right: 1em;
}
.masthead .ui.menu .ui.button {
  margin-left: 0.5em;
}
.masthead h1.ui.header {
  margin-top: 2em;
  margin-bottom: 0em;
  font-size: 4em;
  font-weight: normal;
}
.masthead h2 {
  font-size: 1.7em;
  font-weight: normal;
}

.ui.vertical.stripe {
  padding: 8em 0em;
}
.ui.vertical.stripe h3 {
  font-size: 2em;
}
.ui.vertical.stripe .button + h3,
.ui.vertical.stripe p + h3 {
  margin-top: 3em;
}
.ui.vertical.stripe .floated.image {
  clear: both;
}
.ui.vertical.stripe p {
  font-size: 1.33em;
}
.ui.vertical.stripe .horizontal.divider {
  margin: 3em 0em;
}

.quote.stripe.segment {
  padding: 0em;
}
.quote.stripe.segment .grid .column {
  padding-top: 5em;
  padding-bottom: 5em;
}

.footer.segment {
  padding: 5em 0em;
}

.secondary.pointing.menu .toc.item {
  display: none;
}

@media only screen and (max-width: 700px) {
  .ui.fixed.menu {
    display: none !important;
  }
  .secondary.pointing.menu .item,
  .secondary.pointing.menu .menu {
    display: none;
  }
  .secondary.pointing.menu .toc.item {
    display: block;
  }
  .masthead.segment {
    min-height: 350px;
  }
  .masthead h1.ui.header {
    font-size: 2em;
    margin-top: 1.5em;
  }
  .masthead h2 {
    margin-top: 0.5em;
    font-size: 1.5em;
  }
}

.ui.secondary.inverted.pointing.menu {
  border-color: transparent !important;
}

#diagonal-border {
  -webkit-clip-path: polygon(0% 0%, 0 100%, 100% 100%, 100% 100%, 60% 0%);
  clip-path: polygon(0% 0%, 0 100%, 100% 100%, 100% 100%, 60% 0%);
}
</style>



// WEBPACK FOOTER //
// src/components/landing-page/LandingPage.vue